import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import Profile from "./Pages/Profile/Profile";
import FindMatch from "./Pages/FindMatch/FindMatch";
import About from "./Pages/About/About";
import Verify from "./Pages/Verify/Verify";
import Contact from "./Pages/Contact/Contact";
import { Route, Routes } from "react-router";

const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth" element={<Login />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/findmatch" element={<FindMatch />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="user/:id/verify/:token" element={<Verify />} />
    </Routes>
  );
};

export default Routers;
///:id/verify/:token
